import { Controller } from "@hotwired/stimulus"
import axios from "axios"

export default class extends Controller {
  static targets = ["fileInput", "filenameInput", "form"]
  static values = { url: String }

  async startUpload() {
    if (!this.file) { return }

    const uploadUrl = await this.fetchTemporaryUploadUrl()
    if (!uploadUrl) { return }

    this.element.classList.add("is--loading")

    const response = await axios.put(
      uploadUrl,
      this.file,
      { headers: { "Content-Type": "text/plain" } }
    )

    if (response.status != 200 && response.status != 201) {
      this.element.classList.remove("is--loading")
      return
    }

    if (this.hasFilenameInputTarget) { this.filenameInputTarget.value = this.file.name }
    this.formTarget.requestSubmit()
  }

  async fetchTemporaryUploadUrl() {
    const response = await axios.post(this.urlValue)
    return response?.data?.temporary_upload_url
  }

  get file() {
    if (!this.hasFileInputTarget) { return null }

    return this.fileInputTarget.files[0]
  }
}
